import { render, staticRenderFns } from "./imagesdrag.vue?vue&type=template&id=60089e4a&"
import script from "./imagesdrag.vue?vue&type=script&lang=js&"
export * from "./imagesdrag.vue?vue&type=script&lang=js&"
import style0 from "./imagesdrag.vue?vue&type=style&index=0&id=60089e4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports